<div class="home" id="scroll-to-top-ref">

  <!-- Carousel -->
  <header class="carousel">

    <div class="keen-slider h-100" #slider>
      @for (item of slides; track $index) {
      <div class="keen-slider__slide item bg-{{$index}}">
        <h1 class="title animated fadeInLeft">
          {{item.title}}
        </h1>
        @if (item.boldSubtitle) {
        <h2 class="title-2 animated fadeInLeft">
          {{item.boldSubtitle}}
        </h2>
        }
        @if (item.subtitle) {
        <h3 class="subtitle animated fadeInLeft">
          {{item.subtitle}}
        </h3>
        }
        @defer (on timer(0.5s)) {
        @if (isSessionLoaded() && hasSession()) {
        <button class="btn btn-white animated fadeIn" type="button" [routerLink]="['/shop']">
          Start Shopping
        </button>
        } @else {
        <button class="btn btn-white animated fadeIn" type="button" [routerLink]="['/signup']">
          Sign up today!
        </button>
        }
        }
        <div class="gradient-overlay animated fadeIn"></div>
      </div>
      }
    </div>

    @if (dotHelper().length > 1) {
    <div class="dots animated fadeIn">
      @for (dot of dotHelper(); track $index) {
      <button type="button" title="Slide {{$index + 1}}" (click)="sliderObj.moveToIdx($index)"
        [class]="'dot ' + ($index === currentSlide ? 'active' : '')"></button>
      }
    </div>
    }

    <img class="logo animated fadeInRight" src="/assets/images/logo-footer.webp"
      alt="Carlton Farms logo featuring silhouettes of a cow, pig, and chicken on a red background. Text reads: 'Carlton Farms, Rockmart, GA, Est. 1919, Pasture-Raised Meat, Milk & Eggs." />

  </header>

  <!-- How it works -->
  <section class="how-it-works">

    <header class="text-center">
      <span class="section-subtitle">
        How it Works
      </span>
      <h2 class="section-title">
        It's easy to enjoy Carlton Farms
      </h2>
    </header>

    <div class="list">

      <div class="list__items">
        @for (item of howItWorks(); track $index) {
        <div class="item">
          <div class="item__content">
            <div class="icon">
              <img src="/assets/images/landing/home/how-it-works/icon.svg" alt="How it works icon" />
              <span class="number">
                {{$index + 1}}
              </span>
            </div>
            <div>
              <h3 class="title">
                {{item.title}}
              </h3>
              <p class="h7-semibold m-0">
                {{item.description}}
              </p>
              @if (item.extra) {
              <p class="h7-semibold">
                {{item.extra}}
              </p>
              }
            </div>
          </div>
        </div>
        }
      </div>

      @if (!hasSession()) {
      <button class="btn btn-primary" type="button" [routerLink]="['/signup']">
        Join us today!
      </button>
      }

    </div>

  </section>

  <!-- Why choose us -->
  <section class="why-choose-us">

    <div class="why-choose-us__header">

      <div class="images">
        <img src="/assets/images/landing/home/why-choose-us/family-2.webp" alt="Family photo" />
        <img class="logo" src="/assets/images/logo-footer.webp"
          alt="Carlton Farms logo featuring silhouettes of a cow, pig, and chicken on a red background. Text reads: 'Carlton Farms, Rockmart, GA, Est. 1919, Pasture-Raised Meat, Milk & Eggs." />
      </div>

      <div class="why-choose-us__content">

        <span class="section-subtitle">
          Why Choose Us?
        </span>

        <h1 class="section-title">
          Over 100 years of experience
        </h1>

        <p class="text">
          At Carlton Farms, taking care of our land and animals is in our blood. This farm has been family owned since
          1919, and our dairy cows have been milked here since Louie Carlton started the dairy in 1946. Today, the 3rd,
          4th and 5th generations can all be found working on the farm.
        </p>

      </div>

    </div>

    <div class="why-choose-us__footer">

      <img class="photo" src="/assets/images/landing/home/why-choose-us/family-1.webp" alt="Family photo" />

      <div class="info">

        <div class="info-grid">
          @for (item of whyChooseUs(); track $index) {
          <div class="item">
            <img [src]="item.img" alt="{{item.title}}" />
            <div>
              <h4 class="title">
                {{item.title}}
              </h4>
              <p class="description">
                {{item.description}}
              </p>
            </div>
          </div>
          }
        </div>

        <button class="btn btn-primary" type="button" [routerLink]="['/pages/our-story']">
          Learn more about us
          <span class="material-symbols-outlined">
            arrow_forward
          </span>
        </button>

      </div>

    </div>

  </section>

  <!-- Categories -->
  <section class="categories">

    <header class="text-center px-3">
      <span class="section-subtitle">
        Categories
      </span>
      <h2 class="section-title">
        Find what you need quickly and easily
      </h2>
    </header>

    <div class="categories__list">

      @for (item of categories(); track $index) {
      <div class="item" [routerLink]="item.link">
        <img class="icon" src="/assets/images/landing/home/categories/{{item.icon}}" alt="Icon of {{item.name}}" />
        <span class="name">
          {{item.name}}
        </span>
      </div>
      }

    </div>

  </section>

  <!-- Products -->
  <!-- <section class="products">

    <header class="text-left">
      <span class="section-subtitle">
        Products
      </span>
      <h2 class="section-title">
        Discover Our Products
      </h2>
    </header>

    <section class="header">

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="onTabChange($event)">
        @for (item of discoverProducts(); track $index) {
        <mat-tab [label]="item.name">
        </mat-tab>
        }
      </mat-tab-group>

      <div class="arrows">
        <button class="btn btn-primary" type="button" (click)="productSliderObj.prev()"
          [disabled]="!this.products().length">
          <span class="material-symbols-outlined">
            chevron_left
          </span>
        </button>
        <button class="btn btn-primary" type="button" (click)="productSliderObj.next()"
          [disabled]="!this.products().length">
          <span class="material-symbols-outlined">
            chevron_right
          </span>
        </button>
      </div>

    </section>

    @if (!loadingProducts()) {
    <div class="keen-slider" #productSlider>
      @for (product of products(); track product.id) {
      <div class="keen-slider__slide">
        <app-product-card-v2 [cardResume]="{productDetails: product, settings: {}}"></app-product-card-v2>
      </div>
      }
    </div>
    } @else {
    <section class="mt-5 w-100 d-flex justify-content-center">
      <div class="loader">
        @for (item of [0,0,0,0,0]; track $index) {
        <div class="bg-secondary"></div>
        }
      </div>
    </section>
    }

    <button class="btn btn-outline-primary m-auto btn-lg" type="button" [routerLink]="['/shop']">
      Browse the market!
    </button>

  </section> -->

  <!-- Testimonials -->
  <section class="testimonials">

    <header class="text-center">
      <span class="section-subtitle">
        Testimonials
      </span>
      <h2 class="section-title">
        See What Our Customers Say
      </h2>
    </header>

    <section class="testimonials__list">
      @for (item of testimonialsInView(); track $index) {

      <div class="d-flex align-items-center">

        @if ($index === 1) {
        <button class="btn btn-outline-primary arrow" type="button" (click)="prev()" [disabled]="!showPrevButton()">
          <span class="material-symbols-outlined">
            chevron_left
          </span>
        </button>
        }

        <div class="comment" [class.comment--scale]="$index !== 1" [class.comment--no-box-shadow]="!item">
          @if (item) {
          <img src="/assets/images/landing/home/testimonials/icon.webp" alt="Quote icon">
          <blockquote>
            {{item.comment}}
          </blockquote>
          <div class="d-flex flex-column">
            <cite>
              {{item.author}}
            </cite>
            <span>
              {{item.type}}
            </span>
          </div>
          }
        </div>

        @if ($index === 1) {
        <button class="btn btn-outline-primary arrow" type="button" (click)="next()" [disabled]="!showNextButton()">
          <span class="material-symbols-outlined">
            chevron_right
          </span>
        </button>
        }

      </div>

      }
    </section>

    <div class="dots">
      @for (dot of testimonials(); track $index) {
      <button type="button" title="Slide {{$index + 1}}"
        [class]="'dot ' + ($index === currentTestimonialSlide() ? 'active' : '')"></button>
      }
    </div>

  </section>

  <!-- Farm activities -->
  <section class="farm-activities">

    <header class="text-center">
      <span class="section-subtitle">
        Farm Activities
      </span>
      <h2 class="section-title">
        Our Farm Experiences
      </h2>
    </header>

    <div class="farm-activities__list">

      @for (item of activities(); track $index) {
      <div class="activity">
        <img src="/assets/images/landing/home/activities/{{item.img}}" alt="Image of {{item.title}}">
        <div class="content">
          <h3 class="title">
            {{item.title}}
          </h3>
          <ul>
            @for (description of item.descriptions; track $index) {
            <li class="description">
              {{description}}
            </li>
            }
          </ul>
          <button class="btn btn-primary" type="button" [routerLink]="[item.route]">
            {{item.buttonText}}
          </button>
        </div>
      </div>
      }

    </div>

  </section>

  <!-- Blog -->
  <section class="blog">

    <header>
      <span class="section-subtitle">
        Blog
      </span>
      <h2 class="section-title">
        Carlton Farms Blog
      </h2>
      <button class="btn btn-primary mt-4" type="button" [routerLink]="['/pages/blog']">
        View all
        <span class="material-symbols-outlined">
          arrow_forward
        </span>
      </button>
    </header>

    <div class="row g-2 blog__posts">
      @for (post of posts(); track post.id) {
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <app-post [blog]="post"></app-post>
      </div>
      } @empty {
      <h4 class="h4-regular text-center">
        Oops! It looks like there are no blog posts here right now. Check back soon for updates!
      </h4>
      }
    </div>

  </section>

  <!-- Find us -->
  <section class="find-us">

    <header class="text-center">
      <span class="section-subtitle">
        Find Us
      </span>
      <h2 class="section-title">
        Find the site that best suits you
      </h2>
    </header>

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

      <mat-tab label="Atlanta Delivery Schedule">
        <iframe
          src="https://www.google.com/maps/d/u/0/embed?mid=1yNjpzIO1A1ycR-OJcSFmuzCKphm1K1A&ehbc=2E312F&ll=34.00894980301681%2C-84.54967875&z=10"
          title="Atlanta Delivery Schedule Map"></iframe>
      </mat-tab>

      <mat-tab label="Home Delivery">
        <iframe
          src="https://www.google.com/maps/d/u/0/embed?mid=1uHXS1dtZCPhUxAfVSnRCSnbv8gEWUps&ehbc=2E312F&ll=34.00894980301679%2C-84.54967875&z=9"
          title="Home Delivery"></iframe>
      </mat-tab>

      <mat-tab label="Directions to the Farm">
        <div class="d-flex flex-column">
          <h4 class="address">
            <strong>Carlton Farms:</strong> 1276 Cartersville Hwy, Rockmart, GA 30153 <br>
            Monday- Saturday from 10-6.
          </h4>
          <iframe src="https://www.google.com/maps/d/embed?mid=1K5vBynubQRg8ZmDykJm7huLqLieREIw&ehbc=2E312F"
            title="Directions to the Farm"></iframe>
        </div>
      </mat-tab>

      <!-- <mat-tab label="On-Farm Store">

      </mat-tab> -->

    </mat-tab-group>

  </section>

  <!-- Form -->
  <footer class="form-sign-up">

    <div class="form">

      <div class="info">

        <h4 class="title">
          Get news, updates & special offers!
        </h4>

        <h6 class="subtitle">
          Sign up today & get free home delivery for orders over $100!
        </h6>

        <div class="klaviyo-form-T4TT6t"></div>

      </div>

      <!-- <form>

        <div class="form-floating w-100">
          <input type="text" class="form-control" placeholder="Type your email" />
          <label for="ccLastName">Email</label>
        </div>

        <div class="form-floating w-100">
          <input type="tel" class="form-control" placeholder="Type your phone" />
          <label for="ccLastName">Phone</label>
        </div>

        <button type="button" class="btn btn-primary">
          Sign up!
        </button>

      </form> -->

    </div>

    <img src="/assets/images/landing/home/footer/cows.webp" alt="Three cows">

  </footer>

</div>

<app-footer></app-footer>